import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportIndicadoresUseCase } from "../../../presentation/useCases/read/get_report_indicadores_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

import dayjs from "dayjs";


export class GetReportIndicadoresUseCase implements IGetReportIndicadoresUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportIndicadores(
    requiredMimeType: ReportMimeType | null
  ): Promise<ReportData> {
    const response = await this.repository.getReportIndicadores(requiredMimeType);

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `lista_indicadores_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }
}

